import React, { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Path from '../Common/Path'
import WidgetsIcon from '@mui/icons-material/Widgets';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

export default function Header() {
  const navigate = useNavigate()
  const location = useLocation()
  const dropdownRef = useRef(null);
  const [menuOpen, setmenuOpen] = useState(false)

  function handleMenuToggle() {
    setmenuOpen(!menuOpen)
  }

  useEffect(() => {
    setmenuOpen(false)
  }, [location.pathname])

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth >= 768) {
        setmenuOpen(false);
      }
    }
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    }
  }, [])

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setmenuOpen(false);
      }
    }
    window.addEventListener("click", handleClickOutside);

    return () => {
      window.removeEventListener("click", handleClickOutside);
    }
  }, [])

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setOpen(true);
    }, 2000); // 2000ms = 2 seconds

    return () => clearTimeout(timer); // cleanup
  }, []);

  const [formData, setFormData] = useState({
    fullName: "",
    phone: "",
    email: "",
    description: ""
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSendMessage = () => {
    const { fullName, phone, email, description } = formData;

    const mailtoLink = `mailto:zeacoprofile@gmail.com
            ?subject=Enquiry from ${fullName}
            &body=Full Name: ${fullName}%0A
            Phone: ${phone}%0A
            Email: ${email}%0A
            Description: ${description}%0A`;

    window.location.href = mailtoLink.replace(/\s/g, "");
    setTimeout(() => {
      setFormData({ fullName: "", phone: "", email: "", description: "" });
    }, 500);
  };




  return (
    <div ref={dropdownRef} className='Header shadow'>
      <div className="container">
        <div className="d-flex justify-content-between align-items-center">
          <div onClick={() => {
            setmenuOpen(false)
            navigate(Path.home)
          }} className="logo">
            <img src="/assets/Logo.png" alt="" width={"100%"} height={'60px'} />
          </div>
          <div className="navbar d-none d-md-block">
            <ul className='m-0 p-0'>
              <li onClick={() => navigate(Path.home)} className='btn'>Home</li>

              <li className='btn pro_li'>
                <ul className='m-0 p-0 pro_drop d-flex flex-column'>
                  <div className="d-flex w-100">
                    <div className="p-2" style={{ width: "35%" }}>
                      <div onClick={() => navigate(Path.furniture)} className="btn text-white w-100 text-start btn-outline-light">Furniture</div>
                      <ul>
                        <li onClick={() => navigate("/product/all/main")} className='btn text-white w-100 text-start'><ArrowForwardIosIcon style={{ fontSize: "16px" }} /> Best Seller</li>
                        <li onClick={() => navigate(Path.furniture_office)} className='btn text-white w-100 text-start'><ArrowForwardIosIcon style={{ fontSize: "16px" }} /> Office</li>
                        <li onClick={() => navigate(Path.furniture_kitchen)} className='btn text-white w-100 text-start'><ArrowForwardIosIcon style={{ fontSize: "16px" }} /> Kitchen</li>
                        <li onClick={() => navigate(Path.furniture_drawing)} className='btn text-white w-100 text-start'><ArrowForwardIosIcon style={{ fontSize: "16px" }} /> Drawing Room</li>
                        <li onClick={() => navigate(Path.furniture_cabinet)} className='btn text-white w-100 text-start'><ArrowForwardIosIcon style={{ fontSize: "16px" }} /> Cabinate</li>
                      </ul>
                    </div>
                    <div className="p-2" style={{ width: "25%" }}>
                      <div onClick={() => navigate(Path.doors)} className="btn text-white w-100 text-start btn-outline-light">Doors</div>
                      <ul>
                        <li onClick={() => navigate(Path.doors)} className='btn text-white w-100 text-start'><ArrowForwardIosIcon style={{ fontSize: "16px" }} /> All</li>
                        <li onClick={() => navigate(Path.doors + "/main")} className='btn text-white w-100 text-start'><ArrowForwardIosIcon style={{ fontSize: "16px" }} /> Best Seller</li>
                      </ul>
                    </div>
                    <div className="p-2" style={{ width: "40%" }}>
                      <div onClick={() => navigate(Path.material)} className="btn text-white w-100 text-start btn-outline-light">Material</div>
                      <ul>
                        <li onClick={() => navigate(Path.material)} className='btn text-white w-100 d-flex gap-2'><span><ArrowForwardIosIcon style={{ fontSize: "16px" }} /></span> <span>All</span></li>
                        <li onClick={() => navigate(Path.material_pvc)} className='btn text-white w-100 d-flex gap-2'><span><ArrowForwardIosIcon style={{ fontSize: "16px" }} /></span> <span>PVC Sheets</span></li>
                        <li onClick={() => navigate(Path.material_door)} className='btn text-white w-100 d-flex gap-2'><span><ArrowForwardIosIcon style={{ fontSize: "16px" }} /></span> <span>PVC Door Sheets</span></li>
                        <li onClick={() => navigate(Path.material_hollow)} className='btn text-white w-100 d-flex gap-2'><span><ArrowForwardIosIcon style={{ fontSize: "16px" }} /></span> <span>PVC Hollow Sheets</span></li>
                        <li onClick={() => navigate(Path.material_furniture)} className='btn text-white w-100 d-flex gap-2'><span><ArrowForwardIosIcon style={{ fontSize: "16px" }} /></span> <span>PVC Furniture Sheets</span></li>
                        <li onClick={() => navigate(Path.material_row)} className='btn text-white w-100 d-flex gap-2'><span><ArrowForwardIosIcon style={{ fontSize: "16px" }} /></span> <span>PVC Raw Material</span></li>
                      </ul>
                    </div>
                  </div>
                </ul>
                Products
              </li>
              <li onClick={() => navigate(Path.about)} className='btn'>About Us</li>
              <li onClick={() => navigate(Path.contact)} className='btn'>Contact Us</li>
            </ul>
          </div>
          <div className="navbar d-flex gap-3">
            <div onClick={handleMenuToggle} className="btn btn_primary d-block d-md-none">
              <WidgetsIcon />
            </div>
            <div onClick={handleClickOpen} className="btn btn_primary">
              <QuestionAnswerIcon />
            </div>
          </div>
        </div>
      </div>


      {
        menuOpen ? <div className="d-block d-lg-none w-100">
          <div className="accordion border-0 w-100" id="accordionExample">
            <div className="accordion-item border-0 m-2">
              <h2 onClick={() => navigate(Path.home)} className="accordion-header">
                <button className="btn collapsed" type="button">
                  Home
                </button>
              </h2>
            </div>
            <div className="accordion-item border-0">
              <h2 className="accordion-header">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                  Products
                </button>
              </h2>
              <div id="collapseOne" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                <div className="accordion-body">
                  <ul className='m-0 p-0 d-flex flex-column align-items-start eror'>
                    <li onClick={() => navigate(Path.furniture)} className='btn my-2'><ArrowForwardIosIcon style={{ fontSize: "16px" }} />Furniture</li>
                    <li onClick={() => navigate(Path.doors)} className='btn my-2'><ArrowForwardIosIcon style={{ fontSize: "16px" }} />Doors</li>
                    <li onClick={() => navigate(Path.material)} className='btn my-2'><ArrowForwardIosIcon style={{ fontSize: "16px" }} />Material</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="accordion-item border-0 m-2">
              <h2 onClick={() => navigate(Path.about)} className="accordion-header">
                <button className="btn collapsed" type="button">
                  About Us
                </button>
              </h2>
            </div>
            <div className="accordion-item border-0 m-2">
              <h2 onClick={() => navigate(Path.contact)} className="accordion-header">
                <button className="btn collapsed" type="button">
                  Contact Us
                </button>
              </h2>
            </div>
          </div>
        </div> : ''
      }

      <React.Fragment>
        <Dialog open={open} onClose={handleClose}>
          <DialogTitle className='text_main'>ENQUIRY</DialogTitle>
          <div className="text-muted mx-4">Turn Your Ideas Into Reality. Reach Out Today.</div>
          <DialogContent>
            <div className="row">
              <div className="col-12">
                <TextField
                  required
                  margin="dense"
                  name="fullName"
                  label="Full Name"
                  type="text"
                  fullWidth
                  variant="outlined"
                  value={formData.fullName}
                  onChange={handleChange}
                  sx={{
                    "& label.Mui-focused": {
                      color: "rgb(4, 150, 63)",
                    },
                    "& .MuiOutlinedInput-root": {
                      "&.Mui-focused fieldset": {
                        borderColor: "rgb(4, 150, 63)",
                      },
                    },
                  }}
                />
              </div>
              <div className="col-12 col-md-6">
                <TextField
                  required
                  margin="dense"
                  name="phone"
                  label="Phone Number"
                  type="text"
                  fullWidth
                  variant="outlined"
                  value={formData.phone}
                  onChange={handleChange}
                  sx={{
                    "& label.Mui-focused": {
                      color: "rgb(4, 150, 63)",
                    },
                    "& .MuiOutlinedInput-root": {
                      "&.Mui-focused fieldset": {
                        borderColor: "rgb(4, 150, 63)",
                      },
                    },
                  }}
                />
              </div>
              <div className="col-12 col-md-6">
                <TextField
                  required
                  margin="dense"
                  name="email"
                  label="Email Address"
                  type="email"
                  fullWidth
                  variant="outlined"
                  value={formData.email}
                  onChange={handleChange}
                  sx={{
                    "& label.Mui-focused": {
                      color: "rgb(4, 150, 63)",
                    },
                    "& .MuiOutlinedInput-root": {
                      "&.Mui-focused fieldset": {
                        borderColor: "rgb(4, 150, 63)",
                      },
                    },
                  }}
                />
              </div>
              <div className="col-12">
                <TextField
                  label="Description"
                  margin="dense"
                  multiline
                  fullWidth
                  rows={4}
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  sx={{
                    "& label.Mui-focused": {
                      color: "rgb(4, 150, 63)",
                    },
                    "& .MuiOutlinedInput-root": {
                      "&.Mui-focused fieldset": {
                        borderColor: "rgb(4, 150, 63)",
                      },
                    },
                  }}
                />
                <br /><br />
              </div>
              <div className="col-12">
                <div className="text-muted">
                  For any Query, please mail to: &nbsp;
                  <a className='text_main' href="mailto:zeacoprofile@gmail.com?subject=Enquiry">
                    zeacoprofile@gmail.com
                  </a>
                </div>
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <button className='btn btn_outline' onClick={handleClose}>Cancel</button>
            <button className='btn_primary btn' onClick={handleSendMessage}>Send Message</button>
          </DialogActions>
        </Dialog>
      </React.Fragment>

    </div>
  )
}
